import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Modal,
  Backdrop,
  FormControl,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Grid from "@mui/material/Grid";

import "./CSS/vrfkat1.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import kat1bg from "../Assets/VRF/birinci-kat.png";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect } from "react";

import { Input } from "@mui/material";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_vrf3_tags,
  set_vrf4_tags,
  set_vrf_tags,
  set_external_trend_info,
  set_combine_trends,
} from "../Action/Action";
import { clamp } from "reactflow";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { color } from "highcharts";
import axiosInstance from '../services/axiosConfig';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    flex: 1,
    gap: "3px",

    marginTop: "13%",
    marginLeft: "1%",
  },

  topButtonContainer: {
    position: "absolute",
    top: "4%",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
  },

  pageroot: {
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "relative",
  },

  lockButton: {
    marginLeft: theme.spacing(1),
  },
  floorTitle: {
    position: "absolute",
    top: "9%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "2rem !important",
    fontWeight: 600,
    color: "black",
    padding: theme.spacing(1),
  },
  navigationButtonForward: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  navigationButtonBack: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  button: {
    backgroundColor: "lightgray",
    border: "2px solid rgb(67, 51, 22)",
    height: "5rem",
    width: "16rem",
    fontSize: "0.8rem",
    fontWeight: 700,

    whiteSpace: "nowrap",

    borderRadius: "20px",
    "&:focus": {
      outline: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid rgb(237, 188, 69)",
    boxShadow: theme.shadows[5],
    maxWidth: 400,
    minWidth: 350,
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "3rem",
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  sogutmaısıtma: {
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusLabel: {
    marginRight: theme.spacing(2),
    minWidth: "150px",
    fontWeight: 600,
  },
  formControl: {
    flexGrow: 1,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
}));

const initalState = [
  {
    101: [
      { text: "Oda Sıcaklığı", tagId: "971" },
      { text: "Oda Set Değeri", tagId: "1105", device: "9223" },
      { text: "Cihaz", tagId: "1333", tagId2: "1455", device: "9221" },
      { text: "Çalışma Modu", tagId: "2694", tagId2: "2851", device: "9220" },
      { text: "Çalışma Durumu", tagId: "2694", tagId2: "2851" },

      { text: "Fan Modu", tagId: "8149", tagId2: "2852" },
      { text: "Soğutma Modu Set Değeri", tagId: "1106" },
      { text: "Isıtma Modu Set Değeri", tagId: "1107" },
      { text: "Filtre Durumu", tagId: "1335" },
      { text: "Filtre Reset", tagId: "1605" },
      { text: "Arıza Durumu", tagId: "7228" },
      { text: "Arıza Kodu", tagId: "2693" },
    ],
  },
  {
    102: [
      { text: "Oda Sıcaklığı", tagId: "970" },
      { text: "Oda Set Değeri", tagId: "1099", device: "9218" },
      { text: "Cihaz", tagId: "1329", tagId2: "1454", device: "9215" },
      { text: "Çalışma Modu", tagId: "2690", tagId2: "2848", device: "9216" },
      { text: "Çalışma Durumu", tagId: "2690", tagId2: "2848" },
      { text: "Fan Modu", tagId: "8145", tagId2: "2849" },
      { text: "Soğutma Modu Set Değeri", tagId: "1100" },
      { text: "Isıtma Modu Set Değeri", tagId: "1101" },
      { text: "Filtre Durumu", tagId: "1331" },
      { text: "Filtre Reset", tagId: "1598" },
      { text: "Arıza Durumu", tagId: "7225" },
      { text: "Arıza Kodu", tagId: "2689" },
    ],
  },
  {
    103: [
      { text: "Oda Sıcaklığı", tagId: "969" },
      { text: "Oda Set Değeri", tagId: "1093", device: "9213" },
      { text: "Cihaz", tagId: "1325", tagId2: "1453", device: "9210" },
      { text: "Çalışma Modu", tagId: "2686", tagId2: "2845", device: "9211" },
      { text: "Çalışma Durumu", tagId: "2686", tagId2: "2845" },

      { text: "Fan Modu", tagId: "8141", tagId2: "2846" },
      { text: "Soğutma Modu Set Değeri", tagId: "1094" },
      { text: "Isıtma Modu Set Değeri", tagId: "1095" },
      { text: "Filtre Durumu", tagId: "1327" },
      { text: "Filtre Reset", tagId: "1591" },
      { text: "Arıza Durumu", tagId: "7222" },
      { text: "Arıza Kodu", tagId: "2685" },
    ],
  },
  {
    104: [
      { text: "Oda Sıcaklığı", tagId: "968" },
      { text: "Oda Set Değeri", tagId: "1087", device: "9208" },
      { text: "Cihaz", tagId: "1321", tagId2: "1452", device: "9205" },
      { text: "Çalışma Modu", tagId: "2722", tagId2: "2842", device: "9206" },
      { text: "Çalışma Durumu", tagId: "2722", tagId2: "2842" },

      { text: "Fan Modu", tagId: "8137", tagId2: "2842" },
      { text: "Soğutma Modu Set Değeri", tagId: "1088" },
      { text: "Isıtma Modu Set Değeri", tagId: "1089" },
      { text: "Filtre Durumu", tagId: "1323" },
      { text: "Filtre Reset", tagId: "1585" },
      { text: "Arıza Durumu", tagId: "7219" },
      { text: "Arıza Kodu", tagId: "2681" },
    ],
  },
  {
    105: [
      { text: "Oda Sıcaklığı", tagId: "967" },
      { text: "Oda Set Değeri", tagId: "1081", device: "9203" },
      { text: "Cihaz", tagId: "1317", tagId2: "1451", device: "9200" },
      { text: "Çalışma Modu", tagId: "2678", tagId2: "2839", device: "9201" },
      { text: "Çalışma Durumu", tagId: "2678", tagId2: "2839" },

      { text: "Fan Modu", tagId: "8133", tagId2: "2840" },
      { text: "Soğutma Modu Set Değeri", tagId: "1082" },
      { text: "Isıtma Modu Set Değeri", tagId: "1083" },
      { text: "Filtre Durumu", tagId: "1319" },
      { text: "Filtre Reset", tagId: "1578" },
      { text: "Arıza Durumu", tagId: "7216" },
      { text: "Arıza Kodu", tagId: "2677" },
    ],
  },
  {
    106: [
      { text: "Oda Sıcaklığı", tagId: "966" },
      { text: "Oda Set Değeri", tagId: "1075", device: "9198" },
      { text: "Cihaz", tagId: "1313", tagId2: "1450", device: "9195" },
      { text: "Çalışma Modu", tagId: "2674", tagId2: "2836", device: "9196" },
      { text: "Çalışma Durumu", tagId: "2674", tagId2: "2836" },

      { text: "Fan Modu", tagId: "8129", tagId2: "2837" },
      { text: "Soğutma Modu Set Değeri", tagId: "1076" },
      { text: "Isıtma Modu Set Değeri", tagId: "1077" },
      { text: "Filtre Durumu", tagId: "1315" },
      { text: "Filtre Reset", tagId: "1571" },
      { text: "Arıza Durumu", tagId: "7213" },
      { text: "Arıza Kodu", tagId: "2673" },
    ],
  },
  {
    107: [
      { text: "Oda Sıcaklığı", tagId: "965" },
      { text: "Oda Set Değeri", tagId: "1069", device: "9193" },
      { text: "Cihaz", tagId: "1309", tagId2: "1449", device: "9190" },
      { text: "Çalışma Modu", tagId: "2670", tagId2: "2833", device: "9191" },
      { text: "Çalışma Durumu", tagId: "2670", tagId2: "2833" },

      { text: "Fan Modu", tagId: "8125", tagId2: "2834" },
      { text: "Soğutma Modu Set Değeri", tagId: "1070" },
      { text: "Isıtma Modu Set Değeri", tagId: "1071" },
      { text: "Filtre Durumu", tagId: "1311" },
      { text: "Filtre Reset", tagId: "1564" },
      { text: "Arıza Durumu", tagId: "7210" },
      { text: "Arıza Kodu", tagId: "2669" },
    ],
  },
  {
    108: [
      { text: "Oda Sıcaklığı", tagId: "964" },
      { text: "Oda Set Değeri", tagId: "1063", device: "9188" },
      { text: "Cihaz", tagId: "1305", tagId2: "1448", device: "9185" },
      { text: "Çalışma Modu", tagId: "2666", tagId2: "2830", device: "9186" },
      { text: "Çalışma Durumu", tagId: "2666", tagId2: "2830" },

      { text: "Fan Modu", tagId: "8121", tagId2: "2831" },
      { text: "Soğutma Modu Set Değeri", tagId: "1064" },
      { text: "Isıtma Modu Set Değeri", tagId: "1065" },
      { text: "Filtre Durumu", tagId: "1307" },
      { text: "Filtre Reset", tagId: "1557" },
      { text: "Arıza Durumu", tagId: "7207" },
      { text: "Arıza Kodu", tagId: "2665" },
    ],
  },
  {
    109: [
      { text: "Oda Sıcaklığı", tagId: "963" },
      { text: "Oda Set Değeri", tagId: "1057", device: "9183" },
      { text: "Cihaz", tagId: "1301", tagId2: "1447", device: "9181" },
      { text: "Çalışma Modu", tagId: "2662", tagId2: "2827", device: "9180" },
      { text: "Çalışma Durumu", tagId: "2662", tagId2: "2827" },

      { text: "Fan Modu", tagId: "8117", tagId2: "2828" },
      { text: "Soğutma Modu Set Değeri", tagId: "1058" },
      { text: "Isıtma Modu Set Değeri", tagId: "1059" },
      { text: "Filtre Durumu", tagId: "1303" },
      { text: "Filtre Reset", tagId: "1550" },
      { text: "Arıza Durumu", tagId: "7204" },
      { text: "Arıza Kodu", tagId: "2661" },
    ],
  },
  {
    110: [
      { text: "Oda Sıcaklığı", tagId: "962" },
      { text: "Oda Set Değeri", tagId: "1051", device: "9178" },
      { text: "Cihaz", tagId: "1297", tagId2: "1446", device: "9175" },
      { text: "Çalışma Modu", tagId: "2658", tagId2: "2824", device: "9176" },
      { text: "Çalışma Durumu", tagId: "2658", tagId2: "2824" },

      { text: "Fan Modu", tagId: "8113", tagId2: "2825" },
      { text: "Soğutma Modu Set Değeri", tagId: "1052" },
      { text: "Isıtma Modu Set Değeri", tagId: "1053" },
      { text: "Filtre Durumu", tagId: "1299" },
      { text: "Filtre Reset", tagId: "1543" },
      { text: "Arıza Durumu", tagId: "7201" },
      { text: "Arıza Kodu", tagId: "2657" },
    ],
  },
  {
    111: [
      { text: "Oda Sıcaklığı", tagId: "961" },
      { text: "Oda Set Değeri", tagId: "1045", device: "9173" },
      { text: "Cihaz", tagId: "1293", tagId2: "1445", device: "9170" },
      { text: "Çalışma Modu", tagId: "2654", tagId2: "2821", device: "9171" },
      { text: "Çalışma Durumu", tagId: "2654", tagId2: "2821" },

      { text: "Fan Modu", tagId: "8109", tagId2: "2822" },
      { text: "Soğutma Modu Set Değeri", tagId: "1046" },
      { text: "Isıtma Modu Set Değeri", tagId: "1047" },
      { text: "Filtre Durumu", tagId: "1295" },
      { text: "Filtre Reset", tagId: "1536" },
      { text: "Arıza Durumu", tagId: "7198" },
      { text: "Arıza Kodu", tagId: "2653" },
    ],
  },
  {
    112: [
      { text: "Oda Sıcaklığı", tagId: "960" },
      { text: "Oda Set Değeri", tagId: "1039", device: "9168" },
      { text: "Cihaz", tagId: "1289", tagId2: "1444", device: "9165" },
      { text: "Çalışma Modu", tagId: "2650", tagId2: "2818", device: "9166" },
      { text: "Çalışma Durumu", tagId: "2650", tagId2: "2818" },

      { text: "Fan Modu", tagId: "8105", tagId2: "2819" },
      { text: "Soğutma Modu Set Değeri", tagId: "1040" },
      { text: "Isıtma Modu Set Değeri", tagId: "1041" },
      { text: "Filtre Durumu", tagId: "1291" },
      { text: "Filtre Reset", tagId: "1529" },
      { text: "Arıza Durumu", tagId: "7195" },
      { text: "Arıza Kodu", tagId: "2649" },
    ],
  },
  {
    114: [
      { text: "Oda Sıcaklığı", tagId: "959" },
      { text: "Oda Set Değeri", tagId: "1033", device: "9163" },
      { text: "Cihaz", tagId: "1285", tagId2: "1443", device: "9160" },
      { text: "Çalışma Modu", tagId: "2646", tagId2: "2815", device: "9161" },
      { text: "Çalışma Durumu", tagId: "2646", tagId2: "2815" },

      { text: "Fan Modu", tagId: "8101", tagId2: "2816" },
      { text: "Soğutma Modu Set Değeri", tagId: "1034" },
      { text: "Isıtma Modu Set Değeri", tagId: "1035" },
      { text: "Filtre Durumu", tagId: "1287" },
      { text: "Filtre Reset", tagId: "1522" },
      { text: "Arıza Durumu", tagId: "7192" },
      { text: "Arıza Kodu", tagId: "2645" },
    ],
  },
  {
    115: [
      { text: "Oda Sıcaklığı", tagId: "958" },
      { text: "Oda Set Değeri", tagId: "1027", device: "9158" },
      { text: "Cihaz", tagId: "1281", tagId2: "1442", device: "9155" },
      { text: "Çalışma Modu", tagId: "2642", tagId2: "2812", device: "9156" },
      { text: "Çalışma Durumu", tagId: "2642", tagId2: "2812" },

      { text: "Fan Modu", tagId: "8097", tagId2: "2813" },
      { text: "Soğutma Modu Set Değeri", tagId: "1028" },
      { text: "Isıtma Modu Set Değeri", tagId: "1029" },
      { text: "Filtre Durumu", tagId: "1283" },
      { text: "Filtre Reset", tagId: "1515" },
      { text: "Arıza Durumu", tagId: "7189" },
      { text: "Arıza Kodu", tagId: "2641" },
    ],
  },
  {
    116: [
      { text: "Oda Sıcaklığı", tagId: "957" },
      { text: "Oda Set Değeri", tagId: "1021", device: "9153" },
      { text: "Cihaz", tagId: "1277", tagId2: "1441", device: "9150" },
      { text: "Çalışma Modu", tagId: "2638", tagId2: "2809", device: "9151" },
      { text: "Çalışma Durumu", tagId: "2638", tagId2: "2809" },

      { text: "Fan Modu", tagId: "8093", tagId2: "2810" },
      { text: "Soğutma Modu Set Değeri", tagId: "1022" },
      { text: "Isıtma Modu Set Değeri", tagId: "1023" },
      { text: "Filtre Durumu", tagId: "1279" },
      { text: "Filtre Reset", tagId: "1508" },
      { text: "Arıza Durumu", tagId: "7186" },
      { text: "Arıza Kodu", tagId: "2637" },
    ],
  },
  {
    117: [
      { text: "Oda Sıcaklığı", tagId: "956" },
      { text: "Oda Set Değeri", tagId: "1015", device: "9148" },
      { text: "Cihaz", tagId: "1273", tagId2: "1440", device: "9145" },
      { text: "Çalışma Modu", tagId: "2634", tagId2: "2806", device: "9146" },
      { text: "Çalışma Durumu", tagId: "2634", tagId2: "2806" },

      { text: "Fan Modu", tagId: "8089", tagId2: "2807" },
      { text: "Soğutma Modu Set Değeri", tagId: "1016" },
      { text: "Isıtma Modu Set Değeri", tagId: "1017" },
      { text: "Filtre Durumu", tagId: "1275" },
      { text: "Filtre Reset", tagId: "1501" },
      { text: "Arıza Durumu", tagId: "7183" },
      { text: "Arıza Kodu", tagId: "2633" },
    ],
  },
  {
    118: [
      { text: "Oda Sıcaklığı", tagId: "955" },
      { text: "Oda Set Değeri", tagId: "1009", device: "9143" },
      { text: "Cihaz", tagId: "1269", tagId2: "1439", device: "9140" },
      { text: "Çalışma Modu", tagId: "2630", tagId2: "2803", device: "9141" },
      { text: "Çalışma Durumu", tagId: "2630", tagId2: "2803" },

      { text: "Fan Modu", tagId: "8085", tagId2: "2804" },
      { text: "Soğutma Modu Set Değeri", tagId: "1010" },
      { text: "Isıtma Modu Set Değeri", tagId: "1011" },
      { text: "Filtre Durumu", tagId: "1271" },
      { text: "Filtre Reset", tagId: "1494" },
      { text: "Arıza Durumu", tagId: "7180" },
      { text: "Arıza Kodu", tagId: "2629" },
    ],
  },
  {
    119: [
      { text: "Oda Sıcaklığı", tagId: "954" },
      { text: "Oda Set Değeri", tagId: "1003", device: "9138" },
      { text: "Cihaz", tagId: "1265", tagId2: "1438", device: "9135" },
      { text: "Çalışma Modu", tagId: "2626", tagId2: "2800", device: "9136" },
      { text: "Çalışma Durumu", tagId: "2626", tagId2: "2800" },

      { text: "Fan Modu", tagId: "8081", tagId2: "2801" },
      { text: "Soğutma Modu Set Değeri", tagId: "1004" },
      { text: "Isıtma Modu Set Değeri", tagId: "1005" },
      { text: "Filtre Durumu", tagId: "1267" },
      { text: "Filtre Reset", tagId: "1487" },
      { text: "Arıza Durumu", tagId: "7177" },
      { text: "Arıza Kodu", tagId: "2625" },
    ],
  },
];

let revisedState = {};

initalState.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});

const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  initalState.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
      // tagId2 varsa onu da ekleyelim
      if (item3.tagId2) {
        obj2__.push({ tagId: item3.tagId2 });
      } else if (item3.device) obj2__.push({ tagId: item3.device });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/vrf1") {
        try {
          const request = await axiosInstance.post(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            obj2__
          );
          const response = request.data;

          Store.dispatch(set_vrf_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 2000);
};

setTimeout(() => {
  inital_func();
}, 100);

const VRF1 = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(Array(18).fill(false));

  const [state, Set_state] = useState(initalState);

  const history = useHistory();

  const [render_state, Set_render_state] = useState([]);

  useEffect(() => {
    Set_render_state(props.vrf_tags);
  }, [props.vrf_tags]);

  const [locked, setLocked] = useState({
    101: { odasetdegeri: false },
    102: { odasetdegeri: false },
    103: { odasetdegeri: false },
    104: { odasetdegeri: false },
    105: { odasetdegeri: false },
    106: { odasetdegeri: false },
    107: { odasetdegeri: false },
    108: { odasetdegeri: false },
    109: { odasetdegeri: false },
    110: { odasetdegeri: false },
    111: { odasetdegeri: false },
    112: { odasetdegeri: false },

    114: { odasetdegeri: false },
    115: { odasetdegeri: false },
    116: { odasetdegeri: false },
    117: { odasetdegeri: false },
    118: { odasetdegeri: false },
    119: { odasetdegeri: false },
  });

  //yetkilendirme
  const [vrf_okuma_control, Set_vrf_okuma_control] = useState(false);

  useEffect(() => {
    if (props.yetkilendirme && props.uid !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      console.log(newObj);
      if (newObj !== undefined) {
        if (newObj["VRF"]["Y"] === "t") {
          Set_vrf_okuma_control(true);
        } else {
          Set_vrf_okuma_control(false);
        }
      }
    }
  }, [props.yetkilendirme]);

  const toggleLock = (roomNumber, selectType) => {
    setLocked((prevLocked) => {
      const newLocked = {
        ...prevLocked,
        [roomNumber]: {
          ...prevLocked[roomNumber],
          [selectType]: !prevLocked[roomNumber]?.[selectType],
        },
      };
      console.log("kilitlendi:", newLocked);
      return newLocked;
    });
  };
  const [active_room_number, Set_active_room_number] = useState(null);

  const handleOpen = (index) => {
    let newOpen = [...open];
    newOpen[index] = true;
    setOpen(newOpen);
  };

  const handleClose = (roomNumber) => {
    const index = roomNumber - 101;
    let newOpen = [...open];
    newOpen[index] = false;
    setOpen(newOpen);

    Set_active_room_number(null);
  };

  const sendSetValueFunc = async (list_) => {
    try {
      // companyId ekle (sessionStorage veya localStorage'dan)
      const companyId = (() => {
        try {
          const s = sessionStorage.getItem('TEMPCOM');
          if (s) return parseInt(JSON.parse(s));
        } catch(e) {}
        const l = localStorage.getItem('temp_com_id');
        if (l) return parseInt(l);
        return 1;
      })();
      const payload = { ...list_, companyId };
      console.log("sendSetValueFunc çağrıldı", payload);

      // API çağrısını yap
      const req = await axiosInstance.post(
        "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
        payload
      );

      // API yanıtını işle
      const response = req.data;
      console.log("API yanıtı:", response);
      console.log("HTTP durum kodu:", req.status);

      if (req.status === 200) {
        console.log("API çağrısı başarılı, verileri güncelleniyor.");

        // Tag değerlerini al
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            } else if (item3.device) obj2__.push({ tagId: item3.device });

          });
        });

        console.log("Tag ID'leri:", obj2__);

        // Tag değerlerini al ve güncelle
        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrf1") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              console.log("Tag değerleri alındı:", response);

              Store.dispatch(set_vrf_tags(response));
            } catch (err) {
              console.log("Tag değerleri fetch hatası:", err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };

        await fetch_tag_values();
      } else {
        console.log("API çağrısı başarısız:", req.status);
      }
    } catch (error) {
      console.log("sendSetValueFunc hatası:", error);
    }
  };

  const handleOdaSetDegeriDone = (roomNumber) => {
    const updatedValue = String(odasetdegerler[roomNumber]);
    let tagId;

    state.forEach((item) => {
      if (item[String(roomNumber)]) {
        tagId = item[String(roomNumber)].find(
          (x) => x.text === "Oda Set Değeri"
        )?.tagId;
      }
    });

    if (tagId) {
      sendSetValueFunc({
        TagId: String(tagId),
        TagValue: updatedValue,
      });
    }
  };

  const [isEditingDevice, setIsEditingDevice] = useState(false);

  const handleDeviceEditStart = () => {
    setIsEditingDevice(true);
  };

  const handleDeviceEditCancel = () => {
    setIsEditingDevice(false);
  };

  const handleDeviceEditDone = () => {
    setIsEditingDevice(false);

    let valueToSend = cihazselectValue === "ON" ? "1" : "0";
    let tagId_;

    state.forEach((item) => {
      if (item[String(active_room_number)]) {
        tagId_ = item[String(active_room_number)].find(
          (x) => x.text === "Cihaz"
        )?.tagId;
      }
    });

    if (tagId_ && (cihazselectValue === "ON" || cihazselectValue === "OFF")) {
      sendSetValueFunc({
        TagId: String(tagId_),
        TagValue: valueToSend,
      });
    }
  };

  const [isEditingCalismaModu, setIsEditingCalismaModu] = useState(false);

  const handleCalismaModuEditStart = () => {
    setIsEditingCalismaModu(true);
  };

  const handleCalismaModuEditCancel = () => {
    setIsEditingCalismaModu(false);
  };

  const handleCalismaModuEditDone = () => {
    setIsEditingCalismaModu(false);

    let valueToSend;

    switch (calismamoduselectValue) {
      case "SOĞUTMA":
        valueToSend = "1";
        break;
      case "ISITMA":
        valueToSend = "2";
        break;
      case "FAN":
        valueToSend = "3";
        break;
      case "AUTO":
        valueToSend = "4";
        break;
      case "NEMALMA":
        valueToSend = "5";
        break;
    }
    let tagId_;

    state.forEach((item) => {
      if (item[String(active_room_number)]) {
        tagId_ = item[String(active_room_number)].find(
          (x) => x.text === "Çalışma Modu"
        )?.tagId;
      }
    });

    if (tagId_) {
      sendSetValueFunc({
        TagId: String(tagId_),
        TagValue: valueToSend,
      });
    }
  };

  const [setDegerleri, SETSetDegerleri] = useState(false);
  const [setDegerleri2, SETSetDegerleri2] = useState(false);

  const [isEditingFanModu, setIsEditingFanModu] = useState(false);

  const handleFanModuEditStart = () => {
    setIsEditingFanModu(true);
  };

  const handleFanModuEditCancel = () => {
    setIsEditingFanModu(false);
  };

  const handleFanModuEditDone = () => {
    setIsEditingFanModu(false);

    let valueToSend;

    switch (fanmoduselectValue) {
      case "DÜŞÜK":
        valueToSend = "1";
        break;
      case "HIZLI":
        valueToSend = "2";
        break;
      case "ORTA 2":
        valueToSend = "3";
        break;
      case "ORTA":
        valueToSend = "4";
        break;
      case "OTOMATIK":
        valueToSend = "5";
        break;
    }
    let tagId_;

    state.forEach((item) => {
      if (item[String(active_room_number)]) {
        tagId_ = item[String(active_room_number)].find(
          (x) => x.text === "Fan Modu"
        )?.tagId;
      }
    });

    if (tagId_) {
      sendSetValueFunc({
        TagId: String(tagId_),
        TagValue: valueToSend,
      });
    }
  };

  const [isEditingReset, setIsEditingReset] = useState(false);

  const handleResetEditStart = () => {
    setIsEditingReset(true);
  };

  const handleResetEditCancel = () => {
    setIsEditingReset(false);
  };

  const handleResetEditDone = () => {
    setIsEditingReset(false);

    let valueToSend = resetselectValue === "RESET" ? "1" : "0";
    let tagId_;

    state.forEach((item) => {
      if (item[String(active_room_number)]) {
        tagId_ = item[String(active_room_number)].find(
          (x) => x.text === "Filtre Reset"
        )?.tagId;
      }
    });

    if (
      tagId_ &&
      (resetselectValue === "RESET" || resetselectValue === "NORMAL")
    ) {
      sendSetValueFunc({
        TagId: String(tagId_),
        TagValue: valueToSend,
      });
    }
  };

  const [resetselectValue, setresetSelectValue] = useState("RESET");

  const ResetSelectChange = (event) => {
    setresetSelectValue(event.target.value);
  };
  const [cihazselectValue, setcihazSelectValue] = useState({
    101: "ON",
    102: "ON",
    103: "ON",
    104: "ON",
    105: "ON",
    106: "ON",
    107: "ON",
    108: "ON",
    109: "ON",
    110: "ON",
    111: "ON",
    112: "ON",
    114: "ON",
    115: "ON",
    116: "ON",
    117: "ON",
    118: "ON",
    119: "ON",
  });

  const CihazSelectChange = (event) => {
    setcihazSelectValue(event.target.value);
  };
  const [calismamoduselectValue, setcalismamoduSelectValue] = useState({
    101: "ISITMA",
    102: "ISITMA",
    103: "ISITMA",
    104: "ISITMA",
    105: "ISITMA",
    106: "ISITMA",
    107: "ISITMA",
    108: "ISITMA",
    109: "ISITMA",
    110: "ISITMA",
    111: "ISITMA",
    112: "ISITMA",
    114: "ISITMA",
    115: "ISITMA",
    116: "ISITMA",
    117: "ISITMA",
    118: "ISITMA",
    119: "ISITMA",
  });

  const CalismaModuSelectChange = (event, roomNumber) => {
    var newObj = calismamoduselectValue;
    newObj[roomNumber] = event.target.value;

    setcalismamoduSelectValue(newObj);
  };
  const [fanmoduselectValue, setfanmoduSelectValue] = useState({
    101: "1 ",
    102: "1 ",
    103: "1 ",
    104: "1 ",
    105: "1 ",
    106: "1 ",
    107: "1 ",
    108: "1 ",
    109: "1 ",
    110: "1 ",
    111: "1 ",
    112: "1 ",
    114: "1 ",
    115: "1 ",
    116: "1 ",
    117: "1 ",
    118: "1 ",
    119: "1 ",
  });

  const [cihazled, Setcihazled] = useState({
    101: "green",
    102: "green",
    103: "green",
    104: "green",
    105: "green",
    106: "green",
    107: "green",
    108: "green",
    109: "green",
    110: "green",
    111: "green",
    112: "green",
    114: "green",
    115: "green",
    116: "green",
    117: "green",
    118: "green",
    119: "green",
  });

  const [lock, Setlock] = useState({
    101: "0",
    102: "0",
    103: "0",
    104: "0",
    105: "0",
    106: "0",
    107: "0",
    108: "0",
    109: "0",
    110: "0",
    111: "0",
    112: "0",
    114: "0",
    115: "0",
    116: "0",
    117: "0",
    118: "0",
    119: "0",
  });
  const [lock2, Setlock2] = useState({
    101: "0",
    102: "0",
    103: "0",
    104: "0",
    105: "0",
    106: "0",
    107: "0",
    108: "0",
    109: "0",
    110: "0",
    111: "0",
    112: "0",
    114: "0",
    115: "0",
    116: "0",
    117: "0",
    118: "0",
    119: "0",
  });
  const [lock3, Setlock3] = useState({
    101: "0",
    102: "0",
    103: "0",
    104: "0",
    105: "0",
    106: "0",
    107: "0",
    108: "0",
    109: "0",
    110: "0",
    111: "0",
    112: "0",
    114: "0",
    115: "0",
    116: "0",
    117: "0",
    118: "0",
    119: "0",
  });
  const [filtredurumselectValue, setfiltreselectSelectValue] = useState({
    101: "TEMİZ",
    102: "TEMİZ",
    103: "TEMİZ",
    104: "TEMİZ",
    105: "TEMİZ",
    106: "TEMİZ",
    107: "TEMİZ",
    108: "TEMİZ",
    109: "TEMİZ",
    110: "TEMİZ",
    111: "TEMİZ",
    112: "TEMİZ",
    114: "TEMİZ",
    115: "TEMİZ",
    116: "TEMİZ",
    117: "TEMİZ",
    118: "TEMİZ",
    119: "TEMİZ",
  });
  const [arızadurumselectValue, setarızadurumSelectValue] = useState("NORMAL");
  const [arızakoduselectValue, setarızakoduSelectValue] = useState("0");

  const FanModuSelectChange = (event) => {
    setfanmoduSelectValue(event.target.value);
  };
  const FiltreDurumSelectChange = (event) => {
    setfiltreselectSelectValue(event.target.value);
  };
  const ArızaDurumSelectChange = (event) => {
    setarızadurumSelectValue(event.target.value);
  };
  const ArızaKoduSelectChange = (event) => {
    const selectedArızaKodu = event.target.value;
    setarızakoduSelectValue(selectedArızaKodu);

    if (selectedArızaKodu === "0") {
      setarızadurumSelectValue("NORMAL");
    } else if (selectedArızaKodu === "1") {
      setarızadurumSelectValue("ALARM");
    }
  };

  const initialOdaSetDegerler = {
    101: "25",
    102: "25",
    103: "25",
    104: "25",
    105: "25",
    106: "25",
    107: "25",
    108: "25",
    109: "25",
    110: "25",
    111: "25",
    112: "25",
    114: "25",
    115: "25",
    116: "25",
    117: "25",
    118: "25",
    119: "25",
  };

  const initialSogutmamoduSet = {
    101: "19",
    102: "19",
    103: "19",
    104: "19",
    105: "19",
    106: "19",
    107: "19",
    108: "19",
    109: "19",
    110: "19",
    111: "19",
    112: "19",
    114: "19",
    115: "19",
    116: "19",
    117: "19",
    118: "19",
    119: "19",
  };
  const initialSogutmamoduUst = {
    101: "22",
    102: "22",
    103: "22",
    104: "22",
    105: "22",
    106: "22",
    107: "22",
    108: "22",
    109: "22",
    110: "22",
    111: "22",
    112: "22",
    114: "22",
    115: "22",
    116: "22",
    117: "22",
    118: "22",
    119: "22",
  };
  const initialSogutmamoduAlt = {
    101: "18",
    102: "18",
    103: "18",
    104: "18",
    105: "18",
    106: "18",
    107: "18",
    108: "18",
    109: "18",
    110: "18",
    111: "18",
    112: "18",
    114: "18",
    115: "18",
    116: "18",
    117: "18",
    118: "18",
    119: "18",
  };
  const initialIsıtmamoduSet = {
    101: "28",
    102: "28",
    103: "28",
    104: "28",
    105: "28",
    106: "28",
    107: "28",
    108: "28",
    109: "28",
    110: "28",
    111: "28",
    112: "28",
    114: "28",
    115: "28",
    116: "28",
    117: "28",
    118: "28",
    119: "28",
  };
  const initialIsıtmamoduUst = {
    101: "30",
    102: "30",
    103: "30",
    104: "30",
    105: "30",
    106: "30",
    107: "30",
    108: "30",
    109: "30",
    110: "30",
    111: "30",
    112: "30",
    114: "30",
    115: "30",
    116: "30",
    117: "30",
    118: "30",
    119: "30",
  };
  const initialIsıtmamoduAlt = {
    101: "26",
    102: "26",
    103: "26",
    104: "26",
    105: "26",
    106: "26",
    107: "26",
    108: "26",
    109: "26",
    110: "26",
    111: "26",
    112: "26",
    114: "26",
    115: "26",
    116: "26",
    117: "26",
    118: "26",
    119: "26",
  };

  const [odasetdegerler, setOdasetdegerler] = useState(initialOdaSetDegerler);
  const [initialOdasetdegerler, setInitialOdasetdegerler] = useState(
    initialOdaSetDegerler
  );
  const [sogutmamoduSet, SetsogutmamoduSet] = useState(initialSogutmamoduSet);
  const [initialSogutmaModuSet, setInitialSogutmamoduSet] = useState(
    initialSogutmamoduSet
  );
  const [sogutmamoduUst, SetsogutmamoduUst] = useState(initialSogutmamoduUst);
  const [initialSogutmaModuUst, setInitialSogutmamoduUst] = useState(
    initialSogutmamoduUst
  );
  const [sogutmamoduAlt, SetsogutmamoduAlt] = useState(initialSogutmamoduAlt);
  const [initialSogutmaModuAlt, setInitialSogutmamoduAlt] = useState(
    initialSogutmamoduAlt
  );
  const [ısıtmamoduSet, SetısıtmamoduSet] = useState(initialIsıtmamoduSet);
  const [initialIsıtmaModuSet, setInitialIsıtmamoduSet] =
    useState(initialIsıtmamoduSet);
  const [ısıtmamoduUst, SetısıtmamoduUst] = useState(initialIsıtmamoduUst);
  const [initialIsıtmaModuUst, setInitialIsıtmamoduUst] =
    useState(initialIsıtmamoduUst);
  const [ısıtmamoduAlt, SetısıtmamoduAlt] = useState(initialIsıtmamoduAlt);
  const [initialIsıtmaModuAlt, setInitialIsıtmamoduAlt] =
    useState(initialIsıtmamoduAlt);

  useEffect(() => {
    if (props.vrf_tags.length > 0) {
      console.log(props.vrf_tags);

      const inital_func = () => {
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            } else if (item3.device) obj2__.push({ tagId: item3.device });
          });
        });

        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrf1") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              console.log(response);

              Store.dispatch(set_vrf_tags(response));
              Set_render_state(response);
            } catch (err) {
              console.log(err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };
        fetch_tag_values();
      };

      inital_func();

      var title = [];
      var title2 = [];
      var title3 = [];
      var tag_values_set = [];
      var tag_values_set2 = [];
      var tag_values_set3 = [];
      var tag_values_calisma = [];
      var tag_values_cihaz = [];
      var tag_values_fan = [];
      var tag_values_led = [];
      var tag_values_filtersign = [];
      var tag_values_filtre = [];
      var tag_lock = [];
      var tag_lock2 = [];

      var tag_lock3 = [];

      var newdata = [];
      var newdata2 = [];
      var newdata3 = [];

      state.map((item, index) => {
        var obj_ = [];
        Object.entries(item).forEach((a) => {
          title.push(a[0]);
          title2.push(a[0]);
          title3.push(a[0]);

          obj_.push(a[1]);
        });
        obj_[0].forEach((item_) => {
          props.vrf_tags.forEach((item2) => {
            if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              tag_values_set.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Soğutma Modu Set Değeri"
            ) {
              tag_values_set2.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_lock.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              tag_lock2.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              tag_lock3.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Isıtma Modu Set Değeri"
            ) {
              tag_values_set3.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              console.log(item2.tagValue, item2.tagId);
              tag_values_calisma.push(
                item2.tagValue.trim() === "2"
                  ? "ISITMA"
                  : item2.tagValue.trim() === "1"
                    ? "SOĞUTMA"
                    : item2.tagValue.trim() === "5"
                      ? "NEM ALMA"
                      : item2.tagValue.trim() === "3"
                        ? "FAN"
                        : "AUTO"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_values_cihaz.push(
                item2.tagValue.trim() === "0" ? "OFF" : "ON"
              );
              tag_values_led.push(
                item2.tagValue.trim() === "0" ? "gray" : "green"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Fan Modu"
            ) {
              const valueMapping = {
                1: "DÜŞÜK",
                2: "HIZLI",
                3: "ORTA 2",
                4: "ORTA",
                5: "AUTO",
              };

              tag_values_fan.push(
                valueMapping[item2.tagValue.trim()] || item2.tagValue.trim()
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Filtre Durumu"
            ) {
              tag_values_filtersign.push(
                item2.tagValue.trim() === "1" ? "TEMİZ" : "KİRLİ"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Filtre Durumu"
            ) {
              console.log(item2.tagValue);
              tag_values_filtre.push(
                item2.tagValue.trim() === "1" ? "TEMİZ" : "KİRLİ"
              );
            }
          });
        });
      });

      console.log(tag_values_fan);

      var obj2_7 = {
        101: "TEMİZ",
        102: "TEMİZ",
        103: "TEMİZ",
        104: "TEMİZ",
        105: "TEMİZ",
        106: "TEMİZ",
        107: "TEMİZ",
        108: "TEMİZ",
        109: "TEMİZ",
        110: "TEMİZ",
        111: "TEMİZ",
        112: "TEMİZ",
        114: "TEMİZ",
        115: "TEMİZ",
        116: "TEMİZ",
        117: "TEMİZ",
        118: "TEMİZ",
        119: "TEMİZ",
      };
      var obj2_lock = {
        101: "0",
        102: "0",
        103: "0",
        104: "0",
        105: "0",
        106: "0",
        107: "0",
        108: "0",
        109: "0",
        110: "0",
        111: "0",
        112: "0",
        114: "0",
        115: "0",
        116: "0",
        117: "0",
        118: "0",
        119: "0",
      };
      var obj2_lock2 = {
        101: "0",
        102: "0",
        103: "0",
        104: "0",
        105: "0",
        106: "0",
        107: "0",
        108: "0",
        109: "0",
        110: "0",
        111: "0",
        112: "0",
        114: "0",
        115: "0",
        116: "0",
        117: "0",
        118: "0",
        119: "0",
      };
      var obj2_lock3 = {
        101: "0",
        102: "0",
        103: "0",
        104: "0",
        105: "0",
        106: "0",
        107: "0",
        108: "0",
        109: "0",
        110: "0",
        111: "0",
        112: "0",
        114: "0",
        115: "0",
        116: "0",
        117: "0",
        118: "0",
        119: "0",
      };
      var obj2_5 = {
        101: "green",
        102: "green",
        103: "green",
        104: "green",
        105: "green",
        106: "green",
        107: "green",
        108: "green",
        109: "green",
        110: "green",
        111: "green",
        112: "green",
        114: "green",
        115: "green",
        116: "green",
        117: "green",
        118: "green",
        119: "green",
      };

      var obj2_2 = {
        101: "ISITMA",
        102: "ISITMA",
        103: "ISITMA",
        104: "ISITMA",
        105: "ISITMA",
        106: "ISITMA",
        107: "ISITMA",
        108: "ISITMA",
        109: "ISITMA",
        110: "ISITMA",
        111: "ISITMA",
        112: "ISITMA",
        114: "ISITMA",
        115: "ISITMA",
        116: "ISITMA",
        117: "ISITMA",
        118: "ISITMA",
        119: "ISITMA",
      };

      var obj2_3 = {
        101: "ON",
        102: "ON",
        103: "ON",
        104: "ON",
        105: "ON",
        106: "ON",
        107: "ON",
        108: "ON",
        109: "ON",
        110: "ON",
        111: "ON",
        112: "ON",
        114: "ON",
        115: "ON",
        116: "ON",
        117: "ON",
        118: "ON",
        119: "ON",
      };

      var obj2_4 = {
        101: "1 ",
        102: "1 ",
        103: "1 ",
        104: "1 ",
        105: "1 ",
        106: "1 ",
        107: "1 ",
        108: "1 ",
        109: "1 ",
        110: "1 ",
        111: "1 ",
        112: "1 ",
        114: "1 ",
        115: "1 ",
        116: "1 ",
        117: "1 ",
        118: "1 ",
        119: "1 ",
      };

      var obj2_6 = {
        101: "TEMİZ",
        102: "TEMİZ",
        103: "TEMİZ",
        104: "TEMİZ",
        105: "TEMİZ",
        106: "TEMİZ",
        107: "TEMİZ",
        108: "TEMİZ",
        109: "TEMİZ",
        110: "TEMİZ",
        111: "TEMİZ",
        112: "TEMİZ",
        114: "TEMİZ",
        115: "TEMİZ",
        116: "TEMİZ",
        117: "TEMİZ",
        118: "TEMİZ",
        119: "TEMİZ",
      };

      console.log(tag_values_set, tag_values_set2, tag_values_set3);
      for (let i = 0; i < title.length; i++) {
        newdata[title[i]] = tag_values_set[i].trim();
      }
      for (let i = 0; i < title2.length; i++) {
        newdata2[title[i]] = tag_values_set2[i].trim();
      }
      for (let i = 0; i < title3.length; i++) {
        newdata3[title[i]] = tag_values_set3[i].trim();
      }

      console.log(newdata, newdata2, newdata3, title, title2, title3);

      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_2[String(k + 101)] = tag_values_calisma[k];
        } else {
          obj2_2[String(k + 102)] = tag_values_calisma[k];
        }
      }

      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_3[String(k + 101)] = tag_values_cihaz[k];
        } else {
          obj2_3[String(k + 102)] = tag_values_cihaz[k];
        }
      }

      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_4[String(k + 101)] = tag_values_fan[k];
        } else {
          console.log(k + 102, tag_values_fan[k], k, tag_values_fan[17]);
          obj2_4[String(k + 102)] = tag_values_fan[k];
        }
      }

      console.log(obj2_4);

      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_5[String(k + 101)] = tag_values_led[k];
        } else {
          obj2_5[String(k + 102)] = tag_values_led[k];
        }
      }

      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_6[String(k + 101)] = tag_values_filtersign[k];
        } else {
          obj2_6[String(k + 102)] = tag_values_filtersign[k];
        }
      }
      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_lock[String(k + 101)] = tag_lock[k];
        } else {
          obj2_lock[String(k + 102)] = tag_lock[k];
        }
      }
      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_lock2[String(k + 101)] = tag_lock2[k];
        } else {
          obj2_lock2[String(k + 102)] = tag_lock2[k];
        }
      }
      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_lock3[String(k + 101)] = tag_lock3[k];
        } else {
          obj2_lock3[String(k + 102)] = tag_lock3[k];
        }
      }
      for (let k = 0; k < 18; k++) {
        if (k <= 11) {
          obj2_7[String(k + 101)] = tag_values_filtre[k];
        } else {
          obj2_7[String(k + 102)] = tag_values_filtre[k];
        }
      }

      console.log(obj2_4);

      setOdasetdegerler(newdata);
      SetsogutmamoduSet(newdata2);
      SetısıtmamoduSet(newdata3);

      setcihazSelectValue(obj2_3);

      setfanmoduSelectValue(obj2_4);
      Setcihazled(obj2_5);

      setcalismamoduSelectValue(obj2_2);

      Setlock(obj2_lock);
      Setlock2(obj2_lock2);
      Setlock3(obj2_lock3);

      setfiltreselectSelectValue(obj2_6);
      setfiltreselectSelectValue(obj2_7);
    }
  }, []);

  const handleInputChange = (roomNumber, type) => (event) => {
    const newValue =
      event.target.value === ""
        ? ""
        : Math.max(18, Math.min(30, Number(event.target.value)));

    switch (type) {
      case "odasetdeger":
        setOdasetdegerler((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduSet":
        SetsogutmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduUst":
        SetsogutmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduAlt":
        SetsogutmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduSet":
        SetısıtmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduUst":
        SetısıtmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduAlt":
        SetısıtmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
  }, []);

  // useEffect(() => {
  //   console.log(props.vrf_tags);
  // }, [props.vrf_tags]);

  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const [isEditing5, setIsEditing5] = useState(false);
  const [isEditing6, setIsEditing6] = useState(false);

  const handleEditStart1 = () => {
    setIsEditing1(true);
  };
  const handleEditStart2 = () => {
    setIsEditing2(true);
  };
  const handleEditStart3 = () => {
    setIsEditing3(true);
  };
  const handleEditStart4 = () => {
    setIsEditing4(true);
  };
  const handleEditStart5 = () => {
    setIsEditing5(true);
  };
  const handleEditStart6 = () => {
    setIsEditing6(true);
  };

  const handleEditCancel1 = () => {
    setIsEditing1(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone1 = () => {
    setIsEditing1(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel2 = () => {
    setIsEditing2(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone2 = () => {
    setIsEditing2(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel3 = () => {
    setIsEditing3(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone3 = () => {
    setIsEditing3(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel4 = () => {
    setIsEditing4(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone4 = () => {
    setIsEditing4(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel5 = () => {
    setIsEditing5(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone5 = () => {
    setIsEditing5(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel6 = () => {
    setIsEditing6(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone6 = () => {
    setIsEditing6(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const [active, Set_active] = useState(false);

  const [active_rm2, Set_active_rm2] = useState(false); // render modal 2
  const [changed_values, Set_changed_values] = useState([]);
  const [changed_values2, Set_changed_values2] = useState([]);

  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("SET" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "SET"]);
    }
  }, [odasetdegerler]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Çalışma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Çalışma"]);
    }
  }, [calismamoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Fan" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Fan"]);
    }
  }, [fanmoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Cihaz" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Cihaz"]);
    }
  }, [cihazselectValue]);

  const genel_value_changes = (type, value) => {
    let newdata = changed_values2;
    var toplam_ = 0;
    for (let i of newdata) {
      if (type === i.type) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values2((Prevvalues) => [
        ...Prevvalues,
        { type: type, value: value },
      ]);
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
    const timer = setTimeout(() => {
      Set_changed_values([]);
      Set_changed_values2([]);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const renderModalContent = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            handleClose(roomNumber > 112 ? roomNumber - 1 : roomNumber);
            SETSetDegerleri(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)", textAlign: "center" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {`ODA ${roomNumber}`}
        </Typography>
        <div className="vrf-popup-select">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            if (title.length > 0 && obj_.length > 0) {
              return (
                <div style={{ width: "100%", marginRight: "16px" }}>
                  {obj_[0].map((x, index) => {
                    switch (x.text) {
                      case "Oda Sıcaklığı":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;

                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-sicakligi-label`}
                                id={`oda${roomNumber}-oda-sicakligi-select`}
                                displayEmpty
                                IconComponent={() => null}
                                disabled={!vrf_okuma_control}
                              >
                                <MenuItem>
                                  <span
                                    style={{
                                      display: "flex",
                                      width: "83%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <em
                                      style={{ flex: 1, textAlign: "center" }}
                                    >
                                      {değerler_eleman}
                                    </em>
                                    <span
                                      style={{
                                        position: "relative",
                                        right: "7%",
                                        color: "rgba(0, 0, 0, 0.54)",
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                      }}
                                    >
                                      °C
                                    </span>
                                  </span>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div
                            className={classes.statusRow}
                            id="vrf_pop_up_row"
                          >
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                className="oda-set-degeri-padding"
                                id={`oda${roomNumber}-oda-set-degeri-input`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                value={odasetdegerler[roomNumber]}
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri(true);

                                  handleInputChange(
                                    roomNumber,
                                    "odasetdeger"
                                  )(e);
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][1].device;
                                  }
                                });
                                let value = String(
                                  lock3[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock3((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock3[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        // Normalize cihaz durumu
                        var normalizedCihaz = değerler_eleman !== undefined
                          ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1")
                          : "0";

                        var cihazDurumuText = normalizedCihaz === "0" ? "OFF" : "ON";

                        var cihazRengi = normalizedCihaz === "0" ? "gray" : "green";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor:
                                  cihazRengi || cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.device) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                  }
                                }}
                                id="cihaz_modu_div"
                                className="cihaz_modu_div"
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                              >
                                {cihazDurumuText ||
                                  cihazselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.device || (
                                <ul className="cihaz_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "green",
                                      }));

                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "green";
                                    }}
                                  >
                                    ON
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "gray",
                                      }));
                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "gray";
                                    }}
                                  >
                                    OFF
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][2].device;
                                  }
                                });
                                let value = String(
                                  lock[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Çalışma Modu":
                        // tagId2'lerin listesini tanımla
                        var tagId2ler = [
                          "2851",
                          "2848",
                          "2845",
                          "2842",
                          "2839",
                          "2836",
                          "2833",
                          "2830",
                          "2827",
                          "2824",
                          "2821",
                          "2818",
                          "2815",
                          "2812",
                          "2809",
                          "2806",
                          "2803",
                          "2800",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0];

                          // Normalize çalışma modu değeri
                          var normalizedCalismaModu = değerler_eleman !== undefined
                            ? String(Math.round(Number(değerler_eleman.toString().trim())))
                            : "0";

                          // tagValue değerini işleme alıyoruz
                          var calismaModuText =
                            normalizedCalismaModu === "2"
                              ? "ISITMA"
                              : normalizedCalismaModu === "1"
                                ? "SOĞUTMA"
                                : normalizedCalismaModu === "5"
                                  ? "NEM ALMA"
                                  : normalizedCalismaModu === "3"
                                    ? "FAN"
                                    : "AUTO"; // Varsayılan AUTO olur

                          // tagId2 ve işlenmiş değerleri yazdır
                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${normalizedCalismaModu}, Mod: ${calismaModuText}`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.mode) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                  }
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId2)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId2;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id="calisma_modu_div"
                                className="calisma_modu_div"
                              >
                                {calismaModuText ||
                                  calismamoduselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.mode || (
                                <ul className="calisma_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    ISITMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    SOĞUTMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    NEM ALMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    AUTO
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    FAN
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][3].device;
                                  }
                                });
                                let value = String(
                                  lock2[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock2((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock2[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Durumu
                      case "Çalışma Durumu":
                        // Filtrelenmiş tagId ve tagValue'leri al
                        var çalışmaModuDeğerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);

                        // İlk elemanı al
                        var çalışmaModuEleman = çalışmaModuDeğerler[0];

                        // Normalize çalışma durumu değeri
                        var normalizedCalismaDurumu = çalışmaModuEleman !== undefined
                          ? String(Math.round(Number(çalışmaModuEleman.toString().trim())))
                          : "0";

                        // TagId ve değerleri konsola yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${normalizedCalismaDurumu}`
                        );

                        // Rengi belirle
                        var çalışmaDurumuRengi =
                          normalizedCalismaDurumu === "1"
                            ? "cornflowerblue"
                            : normalizedCalismaDurumu === "2"
                              ? "red"
                              : "gray";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA DURUMU
                            </Typography>
                            <div
                              style={{
                                backgroundColor: çalışmaDurumuRengi,
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                position: "absolute",
                                left: "65%",
                              }}
                            ></div>
                          </div>
                        );

                      case "Fan Modu":
                        var tagId2ler = [
                          "2852",
                          "2849",
                          "2846",
                          "2842",
                          "2840",
                          "2837",
                          "2834",
                          "2831",
                          "2828",
                          "2825",
                          "2822",
                          "2819",
                          "2816",
                          "2813",
                          "2810",
                          "2807",
                          "2804",
                          "2801",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0];

                          // Normalize fan modu değeri
                          var normalizedFanModu = değerler_eleman !== undefined
                            ? String(Math.round(Number(değerler_eleman.toString().trim())))
                            : "0";

                          var fanModuText =
                            normalizedFanModu === "1"
                              ? "DÜŞÜK"
                              : normalizedFanModu === "2"
                                ? "HIZLI"
                                : normalizedFanModu === "3"
                                  ? "ORTA 2"
                                  : normalizedFanModu === "4"
                                    ? "ORTA"
                                    : "AUTO"; // Varsayılan AUTO olur

                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${normalizedFanModu}, Mod: ${fanModuText}`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  borderRadius: "4px",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid #edbc45"
                                    : "2px solid #edbc45",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                id="fan_modu_div"
                                className="fan_modu_div"
                              >
                                {fanModuText ||
                                  fanmoduselectValue[String(roomNumber)]}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>

                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));
                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                opacity: "0",
                                position: "relative",
                                zIndex: "-1000000",
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                    odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Soğutma Modu Set Değeri":
                      // case "Isıtma Modu Set Değeri":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   const labelText = `${
                      //     x.text.toUpperCase().split(" ")[0]
                      //   } MODU <br> SET DEĞERİ`;
                      //   const inputId =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? `oda${roomNumber}-sogutma-modu-set-input`
                      //       : `oda${roomNumber}-isitma-modu-set-input`;
                      //   const inputValue =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? sogutmamoduSet[roomNumber]
                      //       : ısıtmamoduSet[roomNumber];
                      //   const handleInputChangeFunc =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? (e) =>
                      //           handleInputChange(
                      //             roomNumber,
                      //             "sogutmamoduSet"
                      //           )(e)
                      //       : (e) =>
                      //           handleInputChange(
                      //             roomNumber,
                      //             "ısıtmamoduSet"
                      //           )(e);

                      //   const lockedKey =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? "sogutmamoduSet"
                      //       : "ısıtmamoduSet";

                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //         dangerouslySetInnerHTML={{ __html: labelText }}
                      //       />
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //         style={{ minWidth: "60px" }}
                      //       >
                      //         <Input
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-${x.text
                      //             .toLowerCase()
                      //             .replace(/ /g, "-")}-label`}
                      //           className="oda-set-degeri-padding"
                      //           id={inputId}
                      //           sx={{ fontWeight: 600 }}
                      //           type="number"
                      //           disabled={
                      //             locked[roomNumber]?.[lockedKey] ||
                      //             !vrf_okuma_control
                      //           }
                      //           value={inputValue}
                      //           onChange={handleInputChangeFunc}
                      //           endAdornment={
                      //             <InputAdornment
                      //               className="vrf-derece"
                      //               position="end"
                      //             >
                      //               °C
                      //             </InputAdornment>
                      //           }
                      //         />
                      //       </FormControl>
                      //       <IconButton
                      //         onClick={() => toggleLock(roomNumber, lockedKey)}
                      //         className={classes.lockButton}
                      //       >
                      //         {locked[roomNumber]?.[lockedKey] ? (
                      //           <LockIcon />
                      //         ) : (
                      //           <LockOpenIcon />
                      //         )}
                      //       </IconButton>
                      //     </div>
                      //   );

                      // case "Filtre Durumu":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   //
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Select
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-durumu-label`}
                      //           id={`oda${roomNumber}-filtre-durumu-select`}
                      //           className="filtre-durum-class"
                      //           displayEmpty
                      //           value={
                      //             filtredurumselectValue[
                      //               String(active_room_number)
                      //             ]
                      //           }
                      //           onChange={FiltreDurumSelectChange}
                      //           IconComponent={() => null}
                      //         >
                      //           <MenuItem
                      //             value={
                      //               filtredurumselectValue[
                      //                 String(active_room_number)
                      //               ]
                      //             }
                      //           >
                      //             <em>
                      //               {
                      //                 filtredurumselectValue[
                      //                   String(active_room_number)
                      //                 ]
                      //               }
                      //             </em>
                      //           </MenuItem>
                      //         </Select>
                      //       </FormControl>
                      //     </div>
                      //   );
                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,
                      //             width: "155px",
                      //             padding: "1px 14px !important",
                      //             border: "2px solid rgb(237, 188, 69)",
                      //             borderRadius: "4px",
                      //             color: "black",
                      //           }}
                      //           onClick={() => {
                      //             console.log("aa");
                      //             let tagId_;
                      //             state.forEach((a) => {
                      //               if (
                      //                 a[String(active_room_number)] !==
                      //                 undefined
                      //               ) {
                      //                 tagId_ =
                      //                   a[String(active_room_number)][8].tagId;
                      //               }
                      //             });
                      //             if (props.vrf_tags.length > 0) {
                      //               props.vrf_tags.forEach((x) => {
                      //                 console.log(props.vrf_tags, tagId_);
                      //                 if (x.tagId === String(tagId_)) {
                      //                   console.log(x);
                      //                   setfiltreselectSelectValue(
                      //                     (prevValues) => ({
                      //                       ...prevValues,
                      //                       [roomNumber]: "TEMİZ",
                      //                     })
                      //                   );

                      //                   sendSetValueFunc({
                      //                     TagId: String(tagId_),
                      //                     TagValue: "0",
                      //                   });
                      //                 }
                      //               });
                      //             }
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );

                      case "Arıza Durumu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        const arizaDurumuText =
                          değerler_eleman === "1 " ? "ARIZA" : "NORMAL";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                disabled
                                value={arizaDurumuText}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id={`oda${roomNumber}-ariza-durumu-select`}
                                className="ariza-durum-class"
                                style={{
                                  color: "rgb(47, 47, 47)",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <MenuItem value={arizaDurumuText}>
                                  <em className="ariza-durum-text">
                                    {arizaDurumuText}
                                  </em>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Arıza Kodu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);
                        const arizaKoduText =
                          {
                            1: "NORMAL",
                            2: "OTHER ERRORS",
                            3: "REFRIGERATION SYSTEM FAULT",
                            4: "WATER SYSTEM ERROR",
                            5: "AIR SYSTEM ERROR",
                            6: "ELECTRONIC SYSTEM ERROR",
                            7: "SENSOR FAULT",
                            8: "COMMUNICATION ERROR",
                            9: "SYSTEM ERROR",
                          }[değerler_eleman ? değerler_eleman.trim() : ""] ||
                          "BILINMEYEN";

                        return (
                          <div>
                            <div className={classes.statusRow}>
                              <Typography
                                variant="subtitle1"
                                className={classes.statusLabel}
                                style={{ flex: 1, textAlign: "left" }} // Yazıyı sola yaslar
                              >
                                ARIZA KODU
                              </Typography>
                              <FormControl
                                variant="outlined"
                                className={classes.formControl}
                              >
                                <Select
                                  disabled
                                  value={arizaKoduText}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    var tagName = props.tag_list
                                      .filter((b) => b.tagId === x.tagId)
                                      .map((c) => c.tagName)[0];
                                    document.querySelector(
                                      ".show_tagName"
                                    ).innerHTML = tagName;
                                    document
                                      .querySelector(".show_external_trend")
                                      .classList.toggle(
                                        "show_external_trend_active"
                                      );
                                    document.querySelector(
                                      ".show_tagId"
                                    ).innerHTML = x.tagId;
                                    var popup = document.querySelector(
                                      ".show_external_trend"
                                    );
                                    const popupRect =
                                      popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                      newX + popupRect.width >
                                      viewportWidth
                                    ) {
                                      newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                      newY + popupRect.height >
                                      viewportHeight
                                    ) {
                                      newY = viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                      newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                      newY = 0;
                                    }

                                    // Set the position of the popup
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;
                                  }}
                                  id={`oda${roomNumber}-ariza-kodu-select`}
                                  className="ariza-durum-class"
                                  style={{
                                    color: "rgb(47, 47, 47)",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  <MenuItem value={arizaKoduText}>
                                    <em className="ariza-durum-text">
                                      {arizaKoduText}
                                    </em>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <button
                              onClick={() => {
                                let tagidsData = [];
                                initalState.forEach((a) => {
                                  Object.entries(a).forEach((x) => {
                                    if (String(active_room_number) === x[0]) {
                                      x[1].forEach((b) => {
                                        tagidsData.push({
                                          tagName: b.text,
                                          tagId: b.tagId,
                                        });
                                      });
                                    }
                                  });
                                });

                                Store.dispatch(set_combine_trends(tagidsData));
                                history.push("/raporlama");
                              }}
                              className="combine-trend_btn_vrf"
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                margin: "0",
                                padding: "10px",
                              }}
                            >
                              KOMBİNE TREND
                            </button>
                            ;
                          </div>
                        );
                    }
                  })}
                </div>
              );
            }
          })}
        </div>
        {setDegerleri && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  try {
                    for (let i of changed_values) {
                      if (i === "Fan") {
                        //Fan Modu
                        let tagId_44;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_44 = a[String(active_room_number)][5].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_44)) {
                              let fanValue;
                              switch (
                              fanmoduselectValue[String(active_room_number)]
                              ) {
                                case "DÜŞÜK":
                                  fanValue = "1 ";
                                  break;
                                case "HIZLI":
                                  fanValue = "2 ";
                                  break;
                                case "ORTA 2":
                                  fanValue = "3 ";
                                  break;
                                case "ORTA":
                                  fanValue = "4 ";
                                  break;
                                case "AUTO":
                                  fanValue = "5 ";
                                  break;
                                default:
                                  fanValue = "5 "; // Default olarak AUTO
                              }

                              sendSetValueFunc({
                                TagId: String(tagId_44),
                                TagValue: fanValue,
                              });
                            }
                          });
                        }
                      } else if (i === "Çalışma") {
                        //Çalışma Modu

                        let tagId_33;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_33 = a[String(active_room_number)][3].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_33)) {
                              sendSetValueFunc({
                                TagId: String(tagId_33),
                                TagValue:
                                  calismamoduselectValue[
                                    String(active_room_number)
                                  ] === "ISITMA"
                                    ? "2"
                                    : calismamoduselectValue[
                                      String(active_room_number)
                                    ] === "SOĞUTMA"
                                      ? "1"
                                      : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "NEM ALMA"
                                        ? "5"
                                        : calismamoduselectValue[
                                          String(active_room_number)
                                        ] === "FAN"
                                          ? "3"
                                          : "AUTO",
                              });
                            }
                          });
                        }
                      } else if (i === "Cihaz") {
                        //Cihaz

                        let tagId_22;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_22 = a[String(active_room_number)][2].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_22)) {
                              sendSetValueFunc({
                                TagId: String(tagId_22),
                                TagValue:
                                  cihazselectValue[
                                    String(active_room_number)
                                  ] === "OFF"
                                    ? "0 "
                                    : "1 ",
                              });
                            }
                          });
                        }
                      } else if (i === "SET") {
                        //Oda Set Değeri
                        let tagId_;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_ = a[String(active_room_number)][1].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_)) {
                              sendSetValueFunc({
                                TagId: String(tagId_),
                                TagValue: String(
                                  odasetdegerler[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                        handleOdaSetDegeriDone(roomNumber);
                      } else if (i === "Soğutma") {
                        //Soğutma Modu Set Değeri

                        let tagId_2;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_2 = a[String(active_room_number)][5].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_2)) {
                              sendSetValueFunc({
                                TagId: String(tagId_2),
                                TagValue: String(
                                  sogutmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                      } else if (i === "Isıtma") {
                        //Isıtma Set Değeri

                        let tagId_3;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_3 = a[String(active_room_number)][6].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_3)) {
                              sendSetValueFunc({
                                TagId: String(tagId_3),
                                TagValue: String(
                                  ısıtmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }

                        SETSetDegerleri(false);
                      }
                    }

                    Set_changed_values([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderModalContent2 = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            Set_active_rm2(false);
            SETSetDegerleri2(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {"KAT-1 GENEL SİSTEM"}
        </Typography>
        <div className="vrf-popup-select">
          {Object.entries(revisedState).map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            return (
              <div style={{ width: "100%", marginRight: "16px" }}>
                {item.map((x, index) => {
                  if (index < 1) {
                    switch (item[0]) {
                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        const genel_oda_set_değeri = değerler_eleman;
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0].toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                id={`oda-set-degeri-input-all`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                onChange={(e) => {
                                  SETSetDegerleri2(true);
                                  genel_value_changes("SET", 20);

                                  Set_active(true);
                                  değerler_eleman = e.target.value;
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                    odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);

                        var değerler_eleman = değerler[0];

                        var cihazRengi =
                          değerler_eleman === "0 " ? "gray" : "green";

                        // CihazState değerine göre yuvarlağın rengini belirleme

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor: cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              {/* <Select
                                labelId={`oda${roomNumber}-calisma-modu-label`}
                                id={`oda${roomNumber}-calisma-modu-select`}
                                displayEmpty
                                IconComponent={() => null}
                                value={calismamoduselectValue[roomNumber]}
                                onClick={() => {
                                  console.log(calismamoduselectValue);
                                }}
                                onChange={(e) => {
                                  console.log(calismamoduselectValue[roomNumber]);
                                  CalismaModuSelectChange(e, String(roomNumber))
                                }}
                              >
                                <MenuItem value="ISITMA">
                                  <em>ISITMA</em>
                                </MenuItem>
                                <MenuItem value="SOĞUTMA">
                                  <em>SOĞUTMA</em>
                                </MenuItem>
                                <MenuItem value="NemAlma">
                                  <em>NEM ALMA</em>
                                </MenuItem>
                                <MenuItem value="FAN">
                                  <em>FAN</em>
                                </MenuItem>
                              </Select> */}
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                      !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "cihaz_modu_menu_active"
                                  );
                                }}
                                className="cihaz_modu_div"
                              >
                                {değerler_eleman === "0 " ? "OFF" : "ON"}
                              </div>
                              <ul className="cihaz_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;

                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "green";
                                  }}
                                >
                                  ON
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "gray";
                                  }}
                                >
                                  OFF
                                </li>
                              </ul>
                            </FormControl>
                            <div className="vrf-select-icon-kapsayici">
                              {isEditingDevice && (
                                <React.Fragment>
                                  <IconButton
                                    className="vrf-select-ıcons"
                                    onClick={handleDeviceEditDone}
                                    size="small"
                                    style={{ color: "green" }}
                                  >
                                    <DoneIcon />
                                  </IconButton>
                                  <IconButton
                                    className="vrf-select-ıcons"
                                    onClick={handleDeviceEditCancel}
                                    size="small"
                                    style={{ color: "red" }}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </React.Fragment>
                              )}
                            </div>
                            <IconButton
                              onClick={() => toggleLock(roomNumber, "device")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.device ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Çalışma Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "2px solid gray"
                                      : "2px solid rgb(23,23,23)",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                      !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "calisma_modu_menu_active"
                                  );
                                }}
                                className="calisma_modu_div"
                              >
                                {değerler_eleman === "2 "
                                  ? "ISITMA"
                                  : değerler_eleman === "1 "
                                    ? "SOĞUTMA"
                                    : değerler_eleman === "5 "
                                      ? "NEM ALMA"
                                      : "FAN"}
                              </div>
                              <ul className="calisma_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ISITMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  SOĞUTMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  NEM ALMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  FAN
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Fan Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  right: "1%",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid gray"
                                    : "2px solid rgb(23,23,23)",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                className="fan_modu_div"
                              >
                                {değerler_eleman === "1 "
                                  ? "DÜŞÜK"
                                  : değerler_eleman === "2 "
                                    ? "HIZLI"
                                    : değerler_eleman === "3 "
                                      ? "ORTA 2"
                                      : değerler_eleman === "4 "
                                        ? "ORTA"
                                        : değerler_eleman === "5 "
                                          ? "AUTO"
                                          : değerler_eleman}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    genel_value_changes("Fan", textCurrent);

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);
                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA{" "}
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                    odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {item[0].toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,
                      //             height: "2.5rem",

                      //             width: "10rem",
                      //             fontSize: "1rem",
                      //             border: "2px solid rgb(237, 188, 69)",
                      //             borderRadius: "4px",
                      //             color: "black",
                      //           }}
                      //           disabled={!vrf_okuma_control}
                      //           onClick={() => {
                      //             değerler_eleman = değerler_eleman.slice(
                      //               0,
                      //               -1
                      //             );
                      //             revisedState["Filtre Reset"].forEach(
                      //               async (i) => {
                      //                 await sendSetValueFunc({
                      //                   TagId: i,
                      //                   TagValue: değerler_eleman,
                      //                 });
                      //               }
                      //             );
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );
                    }
                  }
                })}
              </div>
            );
          })}
        </div>
        {setDegerleri2 && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  console.log("aa");
                  try {
                    for (let i of changed_values2) {
                      console.log(i);
                      if (i.type === "Fan") {
                        // Fan Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Fan Modu") {
                                let tagValue;

                                // Fan değerlerini belirle
                                switch (i.value) {
                                  case "DÜŞÜK":
                                    tagValue = "1 ";
                                    break;
                                  case "HIZLI":
                                    tagValue = "2 ";
                                    break;
                                  case "ORTA 2":
                                    tagValue = "3 ";
                                    break;
                                  case "ORTA":
                                    tagValue = "4 ";
                                    break;
                                  case "AUTO":
                                    tagValue = "5 ";
                                    break;
                                  default:
                                    tagValue = "5 "; // Default olarak AUTO
                                }

                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: tagValue,
                                });
                              }
                            });
                          });

                          // Fan seçilen değerleri güncelle
                          const fanValue = i.value === "5" ? "AUTO" : i.value;
                          setfanmoduSelectValue({
                            101: fanValue,
                            102: fanValue,
                            103: fanValue,
                            104: fanValue,
                            105: fanValue,
                            106: fanValue,
                            107: fanValue,
                            108: fanValue,
                            109: fanValue,
                            110: fanValue,
                            111: fanValue,
                            112: fanValue,
                            114: fanValue,
                            115: fanValue,
                            116: fanValue,
                            117: fanValue,
                            118: fanValue,
                            119: fanValue,
                          });
                        });
                      } else if (i.type === "Çalışma") {
                        //Çalışma Modu

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Çalışma Modu") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "ISITMA"
                                      ? "2 "
                                      : i.value === "SOĞUTMA"
                                        ? "1 "
                                        : i.value === "NEM ALMA"
                                          ? "5 "
                                          : "3 "
                                  ),
                                });
                              }
                            });
                          });
                          setcalismamoduSelectValue({
                            101: i.value,
                            102: i.value,
                            103: i.value,
                            104: i.value,
                            105: i.value,
                            106: i.value,
                            107: i.value,
                            108: i.value,
                            109: i.value,
                            110: i.value,
                            111: i.value,
                            112: i.value,
                            114: i.value,
                            115: i.value,
                            116: i.value,
                            117: i.value,
                            118: i.value,
                            119: i.value,
                          });
                        });
                      } else if (i.type === "Cihaz") {
                        //Cihaz
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Cihaz") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "OFF" ? "0 " : "1 "
                                  ),
                                });
                              }
                            });
                          });
                          setcihazSelectValue({
                            101: i.value,
                            102: i.value,
                            103: i.value,
                            104: i.value,
                            105: i.value,
                            106: i.value,
                            107: i.value,
                            108: i.value,
                            109: i.value,
                            110: i.value,
                            111: i.value,
                            112: i.value,
                            114: i.value,
                            115: i.value,
                            116: i.value,
                            117: i.value,
                            118: i.value,
                            119: i.value,
                          });
                          Setcihazled({
                            101: i.value === "ON" ? "green" : "gray",
                            102: i.value === "ON" ? "green" : "gray",
                            103: i.value === "ON" ? "green" : "gray",
                            104: i.value === "ON" ? "green" : "gray",
                            105: i.value === "ON" ? "green" : "gray",
                            106: i.value === "ON" ? "green" : "gray",
                            107: i.value === "ON" ? "green" : "gray",
                            108: i.value === "ON" ? "green" : "gray",
                            109: i.value === "ON" ? "green" : "gray",
                            110: i.value === "ON" ? "green" : "gray",
                            111: i.value === "ON" ? "green" : "gray",
                            112: i.value === "ON" ? "green" : "gray",
                            114: i.value === "ON" ? "green" : "gray",
                            115: i.value === "ON" ? "green" : "gray",
                            116: i.value === "ON" ? "green" : "gray",
                            117: i.value === "ON" ? "green" : "gray",
                            118: i.value === "ON" ? "green" : "gray",
                            119: i.value === "ON" ? "green" : "gray",
                          });
                        });
                      } else if (i.type === "SET") {
                        //Oda Set Değeri
                        let value_all_set = document.querySelector(
                          "#oda-set-degeri-input-all"
                        ).value;

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Oda Set Değeri") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId),
                                  TagValue: String(value_all_set),
                                });
                              }
                            });
                          });
                        });

                        setOdasetdegerler({
                          101: String(value_all_set),
                          102: String(value_all_set),
                          103: String(value_all_set),
                          104: String(value_all_set),
                          105: String(value_all_set),
                          106: String(value_all_set),
                          107: String(value_all_set),
                          108: String(value_all_set),
                          109: String(value_all_set),
                          110: String(value_all_set),
                          111: String(value_all_set),
                          112: String(value_all_set),
                          114: String(value_all_set),
                          115: String(value_all_set),
                          116: String(value_all_set),
                          117: String(value_all_set),
                          118: String(value_all_set),
                          119: String(value_all_set),
                        });
                      }
                    }
                    Set_changed_values2([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri2(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri2(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const getTagIdForRoomCihaz = (roomNumber) => {
    const tagIdMap = {
      101: "1333",
      102: "1329",
      103: "1325",
      104: "1321",
      105: "1317",
      106: "1313",
      107: "1309",
      108: "1305",
      109: "1301",
      110: "1297",
      111: "1293",
      112: "1289",
      114: "1285",
      115: "1281",
      116: "1277",
      117: "1273",
      118: "1269",
      119: "1265",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomOperationMode = (roomNumber) => {
    const tagIdMap = {
      101: "2694",
      102: "2690",
      103: "2686",
      104: "2722",
      105: "2678",
      106: "2674",
      107: "2670",
      108: "2666",
      109: "2662",
      110: "2658",
      111: "2654",
      112: "2650",
      114: "2646",
      115: "2642",
      116: "2638",
      117: "2634",
      118: "2630",
      119: "2626",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomSetDeger = (roomNumber) => {
    const tagIdMap = {
      101: "1105",
      102: "1099",
      103: "1093",
      104: "1087",
      105: "1081",
      106: "1075",
      107: "1069",
      108: "1063",
      109: "1057",
      110: "1051",
      111: "1045",
      112: "1039",
      114: "1033",
      115: "1027",
      116: "1021",
      117: "1015",
      118: "1009",
      119: "1003",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAnlik = (roomNumber) => {
    const tagIdMap = {
      101: "971",
      102: "970",
      103: "969",
      104: "968",
      105: "967",
      106: "966",
      107: "965",
      108: "964",
      109: "963",
      110: "962",
      111: "961",
      112: "960",
      114: "959",
      115: "958",
      116: "957",
      117: "956",
      118: "955",
      119: "954",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAriza = (roomNumber) => {
    const arizaTagIdMap = {
      101: "7228",
      102: "7225",
      103: "7222",
      104: "7219",
      105: "7216",
      106: "7213",
      107: "7210",
      108: "7207",
      109: "7204",
      110: "7201",
      111: "7198",
      112: "7195",
      114: "7192",
      115: "7189",
      116: "7186",
      117: "7183",
      118: "7180",
      119: "7177",
    };
    return arizaTagIdMap[roomNumber] || null;
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className={classes.pageroot + " arkaplan"}>
        <div className={classes.topButtonContainer}>
          <button
            onClick={() => {
              Set_active_rm2(true);
            }}
            className="kat-bazı kat_bazı_vrf5"
          >
            KAT 1
          </button>
        </div>

        {active_rm2 && (
          <div key={"sistem1"}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={true}
              onClose={() => { }}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              {renderModalContent2("Sistem Kat-2")}
            </Modal>
          </div>
        )}
        <div className="move-main-vrf">
          <Link to="/VRF">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              ANA EKRAN
            </Button>
          </Link>
        </div>
        <div className="page-move-vrf">
          <Link to="/vrfks">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              Geri
            </Button>
          </Link>
          <Link to="/vrf2">
            <Button
              className={classes.navigationButtonForward + " movebuttonsvrf"}
              variant="contained"
            >
              İleri
            </Button>
          </Link>
        </div>

        <div className={classes.buttonContainer}>
          {open.map((isOpen, index) => {
            let roomNumber = 101 + index;

            const roomClass = `vrf-oda${roomNumber}`;

            // Cihaz durumunu belirleyen tagId
            const tagId = getTagIdForRoomCihaz(roomNumber);

            // Operation mode'ı belirleyen tagId
            const operationModeTagId = getTagIdForRoomOperationMode(roomNumber);

            // Set değerini belirleyen tagId
            const setDegerTagId = getTagIdForRoomSetDeger(roomNumber);

            // Yeni değeri belirleyen tagId
            const anlikTagId = getTagIdForRoomAnlik(roomNumber);

            // Arıza durumunu gösteren tagId
            const arizaTagId = getTagIdForRoomAriza(roomNumber);

            // Cihaz durumunu belirleyen render_state değerleri
            const değerler = render_state
              .filter((a) => String(a.tagId) === tagId)
              .map((b) => b.tagValue);
            const değerler_eleman = değerler[0];

            const cihazDurumuText = değerler_eleman === "0 " ? "OFF" : "ON";
            let cihazRengi =
              değerler_eleman === "0 " ? "lightgray" : "rgb(237, 188, 69)";

            // Arıza durumunu belirleyen render_state değerleri
            const arizaDeğerler = render_state
              .filter((a) => String(a.tagId) === arizaTagId)
              .map((b) => b.tagValue);
            const arizaDurumu = arizaDeğerler[0];

            // Eğer arıza durumu '1' ise cihaz rengi kırmızıya ayarlanır
            if (arizaDurumu === "1 ") {
              cihazRengi = "red";
            }
            // Operation mode'unu belirleyen render_state değerleri
            const operationModeDeğerler = render_state
              .filter((a) => String(a.tagId) === operationModeTagId)
              .map((b) => b.tagValue);
            const operationModeDeğer = operationModeDeğerler[0];

            // Set değerini belirleyen render_state değerleri
            const setDegerDeğerler = render_state
              .filter((a) => String(a.tagId) === setDegerTagId)
              .map((b) => b.tagValue);
            const setDeger = setDegerDeğerler[0];

            // Yeni değerini belirleyen render_state değerleri
            const newValueDeğerler = render_state
              .filter((a) => String(a.tagId) === anlikTagId)
              .map((b) => b.tagValue);
            const newValue = newValueDeğerler[0];

            // Operation mode'a göre renk ayarla
            let operationModeRengi = "gray"; // Varsayılan gri
            if (operationModeDeğer === "1 ") {
              operationModeRengi = "cornflowerblue";
            } else if (operationModeDeğer === "2 ") {
              operationModeRengi = "red";
            }
            return (
              <div key={roomNumber} className="vrf-buttonlar">
                {/* Oda numarası kontrolü ile adjustedRoomNumber hesaplanıyor */}
                {(() => {
                  const adjustedRoomNumber =
                    roomNumber >= 113 ? roomNumber + 1 : roomNumber;

                  // Cihaz durumunu belirleyen tagId
                  const tagId = getTagIdForRoomCihaz(adjustedRoomNumber);

                  // Operation mode'ı belirleyen tagId
                  const operationModeTagId =
                    getTagIdForRoomOperationMode(adjustedRoomNumber);

                  // Set değerini belirleyen tagId
                  const setDegerTagId =
                    getTagIdForRoomSetDeger(adjustedRoomNumber);

                  // Yeni değeri belirleyen tagId
                  const anlikTagId = getTagIdForRoomAnlik(adjustedRoomNumber);

                  // Arıza durumunu gösteren tagId
                  const arizaTagId = getTagIdForRoomAriza(roomNumber);

                  // Cihaz durumunu belirleyen render_state değerleri
                  const değerler = render_state
                    .filter((a) => String(a.tagId) === tagId)
                    .map((b) => b.tagValue);
                  const değerler_eleman = değerler[0];

                  // Normalize cihaz durumu değeri
                  const normalizedCihazDurumu = değerler_eleman !== undefined
                    ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1")
                    : "0";

                  const cihazDurumuText = normalizedCihazDurumu === "0" ? "OFF" : "ON";
                  let cihazRengi = normalizedCihazDurumu === "0"
                      ? "lightgray"
                      : "rgb(237, 188, 69)";

                  // Arıza durumunu belirleyen render_state değerleri
                  const arizaDeğerler = render_state
                    .filter((a) => String(a.tagId) === arizaTagId)
                    .map((b) => b.tagValue);
                  const arizaDurumu = arizaDeğerler[0];

                  // Normalize arıza durumu
                  const normalizedArizaDurumu = arizaDurumu !== undefined
                    ? (Number(arizaDurumu.toString().trim()) === 1 ? "1" : "0")
                    : "0";

                  // Eğer arıza durumu '1' ise cihaz rengi kırmızıya ayarlanır
                  if (normalizedArizaDurumu === "1") {
                    cihazRengi = "red";
                  }

                  // Operation mode'unu belirleyen render_state değerleri
                  const operationModeDeğerler = render_state
                    .filter((a) => String(a.tagId) === operationModeTagId)
                    .map((b) => b.tagValue);
                  const operationModeDeğer = operationModeDeğerler[0];

                  // Normalize operation mode değeri
                  const normalizedOperationMode = operationModeDeğer !== undefined
                    ? String(Math.round(Number(operationModeDeğer.toString().trim())))
                    : "0";

                  // Set değerini belirleyen render_state değerleri
                  const setDegerDeğerler = render_state
                    .filter((a) => String(a.tagId) === setDegerTagId)
                    .map((b) => b.tagValue);
                  const setDeger = setDegerDeğerler[0];

                  // Yeni değerini belirleyen render_state değerleri
                  const newValueDeğerler = render_state
                    .filter((a) => String(a.tagId) === anlikTagId)
                    .map((b) => b.tagValue);
                  const newValue = newValueDeğerler[0];

                  // Operation mode'a göre renk ayarla
                  let operationModeRengi = "gray"; // Varsayılan gri
                  if (normalizedOperationMode === "1") {
                    operationModeRengi = "cornflowerblue";
                  } else if (normalizedOperationMode === "2") {
                    operationModeRengi = "red";
                  }

                  return (
                    <Button
                      className={`${classes.button} ${roomClass} vrfbuttons`}
                      onClick={() => {
                        Set_active_room_number(adjustedRoomNumber);
                        handleOpen(index);
                      }}
                      style={{
                        backgroundColor:
                          cihazRengi || cihazled[String(roomNumber)],
                      }}
                    >
                      {/* Oda numarasını kontrol ederek yazdır */}
                      {`${adjustedRoomNumber}`}

                      {/* Yeni değer için div */}
                      <span
                        style={{
                          position: "absolute",
                          right: "52%",
                          top: "40%",
                          border: "1px solid black",
                          padding: "4px",
                          borderRadius: "5px",
                          fontWeight: "bold",
                          fontSize: "0.8rem",
                        }}
                      >
                        {`ODA : ${newValue} °C`}
                      </span>

                      <div
                        className="operationmodeIndicator"
                        style={{
                          display: "inline-block",
                          backgroundColor: operationModeRengi,
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          marginLeft: "15%",
                          marginTop: "15%",
                        }}
                      ></div>

                      {/* SET : "değer" kısmı */}
                      <span
                        style={{
                          position: "absolute",
                          left: "67%",
                          top: "40%",
                          border: "1px solid black",
                          borderRadius: "5px",
                          padding: "4px",
                          fontWeight: "bold",
                          fontSize: "0.8rem",
                        }}
                      >
                        {`SET : ${setDeger}`}
                      </span>
                    </Button>
                  );
                })()}

                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  open={isOpen}
                  onClose={() => handleClose(index)}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  {/* Modal içeriği de adjustedRoomNumber ile güncelleniyor */}
                  {renderModalContent(
                    roomNumber >= 113 ? roomNumber + 1 : roomNumber
                  )}
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    vrf_tags: state.project_reducer.vrf_tags,
    tag_list: state.project_reducer.tag_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
  };
};

export default connect(MapStateToProps)(VRF1);
